import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat)

import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)

var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');

dayjs.extend(utc)
dayjs.extend(timezone)

if(document.getElementById('app_UserSoldes') != null){

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_UserSoldes', (route, route_utal, route_invoices) =>({
            userSoldes : [],
            subc : null,
            current_Solde : null,
            invoices : [],
            displayAucuneFacture : false,
            modal_userSolde : false,
            modal_userSubscription_utal : false,
            modal_userSubscription_utal_nom  : '',
            modal_userSubscription_utal_id : null,
            modal_userSubscription_error_msg : null,
            init(){
                this.route_utal = route_utal;
                this.route_invoices = route_invoices ?? null;
                this.refresh();

                if(this.route_invoices != null){
                    this.listInvoiceload();
                }
                this.$nextTick(() => {
                    this.modal_userSolde = true;

                })
                setTimeout(() => {
                    this.modal_userSolde = false;
                },100)

                setTimeout(() => {
                    this.modal_userSolde = false;
                },500)
            },

            closeModal(){

                this.$nextTick(() => {
                    this.modal_userSolde = false;

                })


            },
            openModal(id_solde){

                this.$nextTick(() => {
                    this.set_subc(id_solde);
                    this.$nextTick(() => {
                        this.modal_userSolde = true;
                    })

                })

            },
            set_subc(id_solde){
                for (let i = 0; i < this.userSoldes.length; i++) {
                    if(this.userSoldes[i].id == id_solde){
                        this.subc = i;
                        this.$nextTick(() => {
                            this.current_Solde = this.userSoldes[i];
                        })

                        console.log("position sub :"+i)
                        break;
                    }
                }


            },
            refresh(){
                this.userSoldes = [];
                axios({
                    method: 'get',
                    url: route,
                    data: {
                        filterStatus: 'active',
                      }
                }).then(response =>{

                    if(response.data.success){

                        for (let i = 0; i < response.data.CS.length; i++) {
                            let solde = response.data.CS[i];
                            let nbTransactionToDisplay = 3 - 1;
                            if(solde.userCdfs){
                                nbTransactionToDisplay = 0;
                                for (let k = 0; k < solde.userCdfs.length; k++) {
                                    let userCdf = solde.userCdfs[k];
                                    userCdf.UI_coupon_are_hidden = true;
                                    userCdf.UI_coupon_nb_total = userCdf.customer_coupons.length;
                                    userCdf.UI_coupon_nb_waiting = 0;
                                    for (let kk = 0; kk < userCdf.customer_coupons.length; kk++) {
                                        let customer_coupon = userCdf.customer_coupons[kk];
                                        if(customer_coupon.used == 0){
                                            userCdf.UI_coupon_nb_waiting++;

                                        }else if(customer_coupon.used_at != null){
                                            customer_coupon.used_at_beautiful =  dayjs(customer_coupon.used_at).format('DD MMM YYYY');
                                        }
                                    }
                                }
                            }

                            // les transactions
                            for (let j = 0; j < solde.c_s_t.length; j++) {
                                let CST = solde.c_s_t[j];

                                let created_at = dayjs(CST.created_at);
                                let updated_at = dayjs(CST.updated_at);

                                CST.created_at_beautiful = created_at.format('DD MMM YYYY  HH:mm');
                                CST.updated_at_beautiful = updated_at.format('DD MMM YYYY  HH:mm');

                                CST.description_is_hidden = true;


                                if(j > nbTransactionToDisplay){
                                    CST.hide_from_list = true;
                                    solde.some_are_hide_from_list = true;
                                }else{
                                    CST.hide_from_list = false;
                                    solde.some_are_hide_from_list = false;
                                }
                            }



                            solde.created_at_beautiful = dayjs(solde.created_at).format('DD MMM YYYY');
                            solde.updated_at_beautiful = dayjs(solde.updated_at).format('DD MMM YYYY');
                            // On est sur une page unique

                        }

                        this.$nextTick(() => {
                            this.userSoldes = response.data.CS;
                            this.isModalPayementSuccessNeeded();
                        })
                    }


                });
            },

            showTransactionHiddenOfCurrentSub(){


                    // les transactions
                    for (let j = 0; j < this.current_Solde.c_s_t.length; j++) {
                        this.current_Solde.c_s_t[j].hide_from_list = false;
                        this.current_Solde.some_are_hide_from_list = false;
                    }

            },


            listInvoiceload(){
                axios({
                    method: 'get',
                    url: this.route_invoices,
                }).then(response =>{

                    for (let i = 0; i <  response.data.invoices.length; i++) {
                        response.data.invoices[i]['period_start_readable']= dayjs(response.data.invoices[i]['period_start']).format('DD MMM YYYY');
                        response.data.invoices[i]['period_end_readable']= dayjs(response.data.invoices[i]['period_end']).format('DD MMM YYYY');
                        response.data.invoices[i]['created']= dayjs(response.data.invoices[i]['created']).format('DD MMM YYYY');
                    }

                    this.invoices = response.data.invoices;
                    if(this.invoices.length == 0){
                        this.displayAucuneFacture = true;
                    }else{

                    }
                });
            },

            isModalPayementSuccessNeeded(){
                // Obtenez l'URL actuelle
                var currentURL = window.location.href;

                // Vérifiez si le hashtag est présent dans l'URL
                if (currentURL.includes("#payement-success")) {
                    this.open_payement_success_modal();
                }
            },
            open_payement_success_modal(){
                console.log("utiliser "+this.route_utal);

                this.modal_userSubscription_payementsuccess = true;

                this.modal_userSubscription_payementsuccess_nom_pro = this.userSoldes[0].product.pro.nom;
                this.modal_userSubscription_payementsuccess_nom_plan = this.userSoldes[0].name;
            },
            cancel_payement_success_modal(){
                this.modal_userSubscription_payementsuccess = false;
            },
        }))
    })

}
